/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCaretLeft = createReactComponent("outline", "caret-left", "IconCaretLeft", [["path", { "d": "M14 6l-6 6l6 6v-12", "key": "svg-0" }]]);

export { IconCaretLeft as default };
//# sourceMappingURL=IconCaretLeft.mjs.map
